// extracted by mini-css-extract-plugin
export default {"grid-container":"product-card-grid_grid-container__0O68A"};